import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getSupplierSubscriptionReleaseFlags } from '../clients/supplierSubscriptionReleaseFlags.api';

export const supplierSubscriptionReleaseFlags = createQueryKeys('supplierSubscriptionReleaseFlags', {
    current: {
        queryKey: null,
        queryFn: getSupplierSubscriptionReleaseFlags,
    },
});
